import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface ITerms {
  title: string;
  content: string;
  created_at: string | null;
  updated_at: string | null;
}

export interface ITermsPayload {
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export const termsApi = createApi({
  reducerPath: 'terms_api',
  tagTypes: ['terms'],
  baseQuery: axiosBaseQuery(),
  endpoints: build => ({
    getTerms: build.query<ITerms, string>({
      query: () => ({
        url: '/terms',
        method: 'GET',
      }),
      providesTags: ['terms'],
    }),
    updateTerms: build.mutation<void, ITermsPayload>({
      query: body => ({
        url: '/terms',
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['terms'],
    }),
  }),
});

export const { useGetTermsQuery, useUpdateTermsMutation } = termsApi;
